import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import i18n from "i18next";
import localeEn from "locales/en.json";
import localeRu from "locales/ru.json";
import { ThemeProvider } from "styled-components";

import RouterApp from "components/apps/router-app";

import theme from "constants/theme-constants";
import {Toaster} from "react-hot-toast";
import { StorageProvider } from "hooks/useStorage";

i18n.use(initReactI18next).init({
    resources: {
        ru: { translation: localeRu },
        en: { translation: localeEn },
        test: {},
    },
    fallbackLng: "ru",
    interpolation: {
        escapeValue: false,
    },
    lng: localStorage.getItem("lang") || "ru",
});

const App = () => {
    return (
        <StorageProvider>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <RouterApp />
                    <Toaster/>
                </BrowserRouter>
            </ThemeProvider>
        </StorageProvider>
    );
};

export default App;
